import * as React from "react";
import {Glyphicon} from "react-bootstrap";

interface CommentSummaryProps {
    numComments: number;
    classes: string;
}

export default class CommentSummaryIcon extends React.Component<CommentSummaryProps> {
    render() {
        if (this.props.numComments > 0) {
            return (
                <span className="comment-summary-icon float-right spaced">
                    <div className="icon-container">
                        <Glyphicon className={this.props.classes} glyph="comment" style={{lineHeight: '20px', fontSize: '25px'}} />
                        <div className="glyph-text-overlay">
                            {this.props.numComments}
                        </div>
                    </div>
                </span>
            );
        } else {
            return <span/>
        }
    }
}